import { TabItem } from './Item';
import { TabList } from './List';
import { TabPanel } from './Panel';

export const Tab = {
  List: TabList,
  Item: TabItem,
  Panel: TabPanel,
};
